import {
  ADD_EMPLOYEE,
  DELETE_EMPLOYEE,
  GET_EMPLOYEES,
  EMPLOYEE_ERROR,
  UPDATE_EMPLOYEE,
  EXPORT_EMPLOYEE_EXCEL,
  SELECT_EMPLOYEES,
} from 'src/actions/types'

const initialState = {
  employees: {
    data: [],
    current_page: 1,
  },
  filters: {},
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_EMPLOYEES:
      return {
        ...state,
        employees: payload,
        filters: payload.filters,
        loading: false,
      }
    case ADD_EMPLOYEE:
      return {
        ...state,
        employees: { data: [payload, ...state.employees.data] },
        loading: false,
      }
    case UPDATE_EMPLOYEE: {
      const employees = state.employees.data.map((employee) =>
        employee.id === payload.id ? { ...employee, ...payload } : employee,
      )
      return {
        ...state,
        employees: { ...state.employees, data: employees },
        loading: false,
      }
    }
    case DELETE_EMPLOYEE:
      return {
        ...state,
        employees: { data: state.employees.data.filter((employee) => employee.id !== payload) },
        loading: false,
      }
    case EXPORT_EMPLOYEE_EXCEL:
      return state
    case SELECT_EMPLOYEES:
      return {
        ...state,
        employees: { data: payload },
        loading: false,
      }
    case EMPLOYEE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
